<div class="search-container">
  <div>
    <span><b>Pesquisar por nome</b></span>
    <input [formControl]="nameControl" type="text" autofocus (keyup.enter)="searchUserByName()" />
  </div>

  <div class="icon-container" (click)="searchUserByName()">
    <mat-icon aria-hidden="false">search</mat-icon>
  </div>
</div>

<div class="user-card-container">
  <div *ngIf="isResultEmpty()">
    <p>Nenhum resultado encontrado.</p>
  </div>

  <div *ngFor="let userItem of pageableResult.getItems()" class="user-card">
    <div class="data-container">
      <p class="name">{{ userItem.getName() }}</p>

      <div class="data">
        <span class="email">
          <span class="semi-bold">E-mail: </span>
          {{ userItem.getEmail() }}</span
        >
        <span class="perfil">
          <span class="semi-bold">Perfis: </span>
          <span *ngFor="let userRole of userItem.getUserRoleList()">{{ userRole.getName() }}</span></span
        >
      </div>
    </div>

    <div class="control-container">
      <div *ngIf="userItem.isActivate()" class="btn active">
        <mat-icon aria-hidden="false">check_circle_outline</mat-icon>
        <span>ATIVO</span>
      </div>

      <div *ngIf="!userItem.isActivate()" class="btn inactive">
        <mat-icon aria-hidden="false">delete</mat-icon>
        <span>INATIVO</span>
      </div>

      <div class="btn edit-btn" (click)="goToEditUser(userItem)">
        <mat-icon aria-hidden="false">edit_note</mat-icon>
        <span>{{ hasAccessToEditUser() ? "EDITAR" : "VISUALIZAR" }}</span>
      </div>
    </div>
  </div>

  <div class="more-btn-container" *ngIf="showMoreUsersBtn()">
    <a class="btn more-users-btn" (click)="searchMoreUsers()">carregar mais registros</a>
  </div>
</div>
